export default __webpack_public_path__ + "static/header-03231388eccd136c00a99ebd7e19573b.png";